export function toMoney(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  return Math.round(x * 100) / 100;
}

export function formatEur(n) {
  return `${toMoney(n).toFixed(2).replace(".", ",")} €`;
}

export function lineImporte(cantidad, pvp, dto = 0) {
  const neto = Number(cantidad) * Number(pvp);
  const impDto = (neto * Number(dto || 0)) / 100;
  return toMoney(neto - impDto);
}

export function calcCambio(total, entregaEfectivo, entregaTarjeta) {
  return toMoney(
    Number(entregaEfectivo || 0) + Number(entregaTarjeta || 0) - Number(total || 0),
  );
}

export function formatTpvDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
